module.exports = __webpack_public_path__ + "img/13.0c6465bb.jpg";